import script from "./WordInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./WordInfo.vue?vue&type=script&setup=true&lang=js"

import "./WordInfo.vue?vue&type=style&index=0&id=73dc1cfe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73dc1cfe"]])

export default __exports__